import { type FormikValues, useFormikContext } from "formik";
import lodashGet from "lodash/get";
import React, { type ComponentPropsWithoutRef } from "react";
import { useAutoResizeTextarea } from "shared/hooks/useAutoResizeTextarea";
import PillarFormInputWrapper, {
  type PillarFormInputWrapperProps,
} from "./PillarFormInputWrapper";

export type PillarFormTextAreaInputProps = PillarFormInputWrapperProps &
  Omit<ComponentPropsWithoutRef<"textarea">, "value" | "id"> & {
    minRows?: number;
    maxRows?: number;
  };

const PillarFormTextAreaInput = ({
  name,
  labelClassName,
  testid,
  label,
  additionalClasses,
  onChange,
  minRows,
  maxRows,
  ...props
}: PillarFormTextAreaInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const disabled = minRows === undefined && maxRows === undefined;
  const { ref } = useAutoResizeTextarea({
    disabled,
    value: lodashGet(values, name),
    minRows,
    maxRows,
  });

  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      label={label}
      additionalClasses={additionalClasses}
    >
      <textarea
        ref={ref}
        data-testid={testid}
        value={lodashGet(values, name)}
        name={name}
        id={name}
        onChange={(e) => {
          setFieldValue(name, e.target.value);
          onChange?.(e);
        }}
        {...props}
      />
    </PillarFormInputWrapper>
  );
};

export default PillarFormTextAreaInput;
